import { Component, OnInit, Input, DoCheck, Optional, Output, EventEmitter } from '@angular/core';
import { FormControl, Validators, FormGroup, AbstractControl, ControlContainer, FormGroupDirective, ValidationErrors, ValidatorFn } from '@angular/forms';
import { ErrorMassageValidation } from '../../Shared/services/validationErrorMassage.service';
import { TextBoxOptions } from '../../Shared/Models/TextBoxOptions';
import { InputType } from '../../Shared/Enums/InputType';
import { UtilityService } from '../../Shared/services/UtilityService';
import { ControlUtility } from '../../Shared/services/ControlUtility';
import { TagsInputOptions } from '../../Shared/Models/TagsInputOptions';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';


@Component({
  // tslint:disable-next-line: component-selector
  selector: 'BBSF-TagsInput',
  templateUrl: './TagsInput.component.html',
  styleUrls: ['./TagsInput.component.scss']
})
export class TagsInputComponent implements OnInit {


  static controlContainerstatic = null;
  // tslint:disable-next-line: max-line-length
  constructor(private http: HttpClient, private ErrorHandler: ErrorMassageValidation, private controlUtility: ControlUtility, @Optional() private controlContainer: ControlContainer, public TagsInputControlHost: FormGroupDirective) {
    TagsInputComponent.controlContainerstatic = this.controlContainer;
  }
  @Input() group: FormGroup;
  @Input() options: TagsInputOptions;
  @Output() OnChange = new EventEmitter();

  // TagInputControl: AbstractControl;
  SelectedId: any[] = []
  tags = [];
  NewSelectionValidationKey: string = "";
  TagsFormGroup: FormGroup;
  TagsFormControl: AbstractControl
  IsNoMatch: any
  markAllAsTouched: boolean = false;
  validationRules = [];
  validationRulesasync = [];
  static showErrorOfInputs(errors: any) {

    const controlContainerstatic = TagsInputComponent.controlContainerstatic;
    const formGroup = controlContainerstatic.control as FormGroup;
    for (const key in errors) {
      if (errors.hasOwnProperty(key)) {
        for (const iterator of errors[key]) {
          const formControl = formGroup.get(key) as FormControl;
          formControl.setErrors({ "FluentApi": iterator });
          formControl.markAsTouched();
        }
      }
    }
  }

  ngOnInit() {
    UtilityService.isCreatedBefor = false
    this.options.DatasourceItemText = this.options.DatasourceItemText.toLowerCase();
    this.TagsFormGroup = new FormGroup({});;
    this.TagsFormGroup.addControl("tags", new FormControl(''));
    this.TagsFormControl = this.TagsFormGroup.controls["tags"]; //  new FormControl('',validationRules);
    this.group.addControl(this.options.Name, this.TagsFormControl);

    if (this.options.LabelKey != null && this.options.LabelKey != "")
      this.options.LabelValue = UtilityService.getResourceValue(this.options.LabelKey);


    // this.group.addControl(this.options.Name, new FormControl(''));
    // this.TagInputControl = this.group.controls[this.options.Name]; //  new FormControl('',validationRules);

    this.TagsFormControl.setValue(this.options.Value);

    if (this.options.CustomValidation.length > 0) {
      let Validations = this.options.CustomValidation
      for (let index = 0; index < Validations.length; index++) {
        const Validation = Validations[index];
        this.validationRules.push(Validation.functionBody);
      }

    }


    if (this.options.IsRequired) {
      this.validationRules.push(Validators.required);
    }
    this.TagsFormControl.setValidators(this.validationRules);
    this.TagsFormControl.setAsyncValidators(this.validationRulesasync);
    if (this.options.IsDisabled) {
      this.TagsFormControl.disable();
    }

    if (this.options.Value != undefined && this.options.Value != []) {
      for (let index = 0; index < this.options.Value.length; index++) {
        const element = this.options.Value[index];
        this.SelectedId.push(element.key);
      }
      this.tags = this.options.Value
      this.TagsFormControl.setValue(this.options.Value);
    }

    this.TagsInputControlHost.ngSubmit.subscribe((value) => {
      this.group.markAllAsTouched()
      this.markAllAsTouched = true
    })
  }


  ngAfterViewInit(): void {
    if (this.options.AttributeList != null) {
      var element = document.getElementById(this.options.Name);
      for (let index = 0; index < this.options.AttributeList.length; index++) {
        element.setAttribute(this.options.AttributeList[index].Key, this.options.AttributeList[index].value);
      }

    }

    let inputElement = document.getElementById(this.options.Name).getElementsByTagName("input")[0]
    inputElement.setAttribute("autocomplete", "off")
  }

  resetError = () => {
    UtilityService.RemoveGlobalError();
  }

  showGlobalError() {
    this.controlUtility.showGlobalError()
  }

  getErrorValidation(ErrorList) {
    if (this.markAllAsTouched && this.group.invalid) {
      this.showGlobalError()
      this.markAllAsTouched = false
    }

    return this.controlUtility.getErrorValidationMassage(ErrorList, this.group, this.options);
  }


  copyInputMessage(inputElement) {
    this.controlUtility.CopyInputMessage(inputElement)
  }

  searchFunctionFactory(Text: any): Observable<object> {
    let Url = `${this.options.ActionURL}?${this.options.QueryParamName}=${Text}&SelectedItems=${this.SelectedId}`
    let Model = this.http.get(Url)
    return Model as any;
  }


  AddTag(event, key) {
    if (this.IsNoMatch == true && this.options.AllowNewSelection == false && (key.selected != null || key.selected != "")) {
      this.TagsFormControl.setErrors({ "errorMassage": this.options.NoResultText });
      this.TagsFormControl.markAsTouched();
      this.TagsFormControl.invalid;
    }
    else if (this.IsNoMatch == false && this.options.AllowNewSelection == false) {
      this.TagsFormControl.clearValidators();
      this.TagsFormControl.updateValueAndValidity();
      this.TagsFormControl.valid;
    }
    else if (this.IsNoMatch == true && event == "Enter" && this.options.AllowNewSelection && key.selected) {
      if (!(this.tags.length >= this.options.MaxNumberTags)) {
        this.tags.push({ key: "", value: key.selected });
        key.selected = null;
      }
    }
  }

  onTagsChanged(result) {
    console.log(this.tags)

    if (result["change"] == "add") {
      this.SelectedId.push(result.tag.key);
    }
    if (result["change"] == "remove") {
      this.SelectedId = this.SelectedId.filter((item) => item != result.tag.key);
      if (this.SelectedId.length == 0 && this.options.IsRequired == true) {
        this.TagsFormControl.setErrors({ required: "" });
        this.TagsFormControl.markAsTouched();
        this.TagsFormControl.invalid;
      }
    }

    this.OnChange.emit(this.TagsFormControl.value)
  }

  onNoOptionsMatch(event) {
    this.IsNoMatch = event;
  }

  //External Method
  RemoveRequiredValidation = () => {
    this.controlUtility.RemoveRequiredValidation(this.TagsFormControl, this.validationRules, this.options)
  }
  //External Method
  AddRequiredValidation = () => {
    this.controlUtility.AddRequiredValidation(this.TagsFormControl, this.validationRules, this.options)
  }
  //External Method
  RemoveCustomValidation = (CustomValidation) => {
    this.controlUtility.RemoveCustomValidation(this.TagsFormControl, this.validationRules, CustomValidation)
  }
  //External Method
  AddCustomValidation = (CustomValidation) => {
    this.controlUtility.AddCustomValidation(this.TagsFormControl, this.validationRules, CustomValidation)
  }

  //External Method
  IsValid = () => {
    this.controlUtility.IsValid(this.TagsFormControl)
  }
}


